import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppType = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "appType",
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17532",
		"data-name": "Group 17532",
		transform: "translate(3.333 2)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12958",
				"data-name": "Path 12958",
				d: "M12.057,15H6.333A1.333,1.333,0,0,1,5,13.667V4.333A1.333,1.333,0,0,1,6.333,3h4.781a1.334,1.334,0,0,1,.943.391l1.885,1.885a1.334,1.334,0,0,1,.391.943v6.264a3.265,3.265,0,0,1-.477,1.934A3.075,3.075,0,0,1,12.057,15Z",
				transform: "translate(-5 -3)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12959",
				"data-name": "Path 12959",
				d: "M8,9h5.333",
				transform: "translate(-6 -5)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12960",
				"data-name": "Path 12960",
				d: "M8,12h5.333",
				transform: "translate(-6 -6)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12961",
				"data-name": "Path 12961",
				d: "M8,15H9.333",
				transform: "translate(-6 -7)",
				fill: "none",
				stroke: "#666",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12964",
		"data-name": "Path 12964",
		d: "M0,0H16V16H0Z",
		fill: "none"
	})]
});
export default SvgAppType;
